import type { ApolloClient } from "@apollo/client";
import type { Dispatch } from "redux";

import { beneficiaryConstants } from "./types";
import {
  getAllBeneficiaries,
  updateBeneficiaries as updateBeneficiariesByAccount,
  deleteAllBeneficiaries,
} from "services/beneficiaryService";
import ActionCreator from "utils/actionHandler";

export const getBeneficiaries = (
  client: ApolloClient<object>,
  accountId: string
) => {
  return (dispatch: Dispatch) => {
    const actionCreator = new ActionCreator<
      Awaited<ReturnType<typeof getAllBeneficiaries>>
    >(beneficiaryConstants.GET_BENEFICIARIES);
    return actionCreator.dispatchFullLifecycle(
      dispatch,
      getAllBeneficiaries(client, accountId)
    );
  };
};

export const updateBeneficiaries = (
  client: ApolloClient<object>,
  beneficiariesInput: Parameters<typeof updateBeneficiariesByAccount>[1]
) => {
  return (dispatch: Dispatch) => {
    const actionCreator = new ActionCreator<
      Awaited<ReturnType<typeof updateBeneficiariesByAccount>>
    >(beneficiaryConstants.UPDATE_BENEFICIARIES);
    return actionCreator.dispatchFullLifecycle(
      dispatch,
      updateBeneficiariesByAccount(client, beneficiariesInput)
    );
  };
};

export const deleteBeneficiaries = (
  client: ApolloClient<object>,
  accountId: string
) => {
  return (dispatch: Dispatch) => {
    const actionCreator = new ActionCreator<
      Awaited<ReturnType<typeof deleteAllBeneficiaries>>
    >(beneficiaryConstants.DELETE_BENEFICIARIES);
    return actionCreator.dispatchFullLifecycle(
      dispatch,
      deleteAllBeneficiaries(client, accountId)
    );
  };
};

export default {
  getBeneficiaries,
  updateBeneficiaries,
  deleteBeneficiaries,
};
